module.exports = __webpack_public_path__ + "static/media/logo-white.8aa30908.svg";